// safeNext is where to go after signing in: the ?next= path when it stays on
// this host, else the dashboard. Parsing it against our own origin and
// comparing origins catches every spelling that leaves the host (//, /\,
// tabs and newlines the URL parser strips, other schemes); the raw-character
// check refuses what a browser would silently rewrite before navigating.
export const safeNext = (next, origin) => {
  if (!next || typeof next !== "string" || !next.startsWith("/") || /[\\\s]|%0[ad]/i.test(next)) {
    return "/";
  }
  try {
    const url = new URL(next, origin);
    if (url.origin !== origin) return "/";
    return url.pathname + url.search + url.hash;
  } catch {
    return "/";
  }
};

// loginTarget is where a password login lands: ?next= when given, else the
// page the sign-in form was shown on (it renders in place of any route).
export const loginTarget = (next, here, origin) => safeNext(next || here, origin);
